import { AddSystemRequestSchema, AddSystemResponseSchema } from './add-system.schema';
/**
 * Add System Endpoint Contract
 * Creates a new system in the organization
 */ export const addSystemContract = {
    method: 'POST',
    path: '/api/v2/system',
    description: 'Create a new system in the organization',
    requestSchema: AddSystemRequestSchema,
    responseSchema: AddSystemResponseSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=add-system.contract.js.map